import { Taxonomy } from '../home/types/types';
import { useEffect } from 'react';
import GoogleEvent from '../utils/gaEvent';

const useViewItemEvent = (
  item_id: string | number,
  item_name: string,
  affiliation: string,
  item_brand: string | undefined,
  categories: Taxonomy[] | undefined,
  price_currency: string,
  price: string
) => {
  useEffect(() => {
    const viewItemEvent = new GoogleEvent('view_item');
    const itemCategories = GoogleEvent.generateItemCategories(categories ?? []);
    viewItemEvent.eventParams = {
      currency: price_currency,
      value: price,
      items: [
        {
          item_id,
          item_name,
          affiliation,
          item_brand: item_brand || '',
          ...itemCategories,
          item_list_id: item_id,
          item_list_name: item_name,
          price,
        },
      ],
    };

    viewItemEvent.sendEvent();
  }, [item_id, item_name, affiliation, item_brand, categories, price_currency, price]);
};

export default useViewItemEvent;
